"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function AboutHeader() {
  return <ResponsiveHeader />
}
